export default __webpack_public_path__ + "static/media/NASA_JPL.dc3ddbdc.png";